<script setup>
import { ref, reactive, onMounted } from 'vue'
import Decimal from './break_eternity.min.js'
import merge from 'lodash/merge'
let D = Decimal;
let E = D.fromNumber;
let F = D.fromString;
const base = {
	a: E(1), // amount of manifolds
	ads: [ // amount of producers
		null,
		E(0),E(0),E(0),E(0),
	],
	adps: [ // amount of purchased producers
		null,
		E(0),E(0),E(0),E(0),
	],
	adcms: [ // cost multipliers
		null,
		E(10),E(1e3),E(1e7),E(1e11),
	],
	adics: [ // initial costs
		null,
		E(1),E(100),E(1e5),E(1e7),
	],
	tick: E(0), // amount of theorems
	prestige: {
		points: E(0),
		maxPoints: E(0),
		times: E(0),
		upgs: [
			null,
			false,false,
			false,false,
			false,false,
			false,false,
		],
		autobuy: E(1),
		autobuyers: [
			null,
			false,false,false,false,false,false,
		]
	},
	chall: {
		flune: {
			in: 0,
			comp: [null,0]
		}
	},
	flunes: E(0),
	maxFlunes: E(0),
	ver: 260723
};
let g = reactive(base);
const tab = ref("dim");
const dTime = 62.5 / 1000;
let hardcap = F("e9e15")
onMounted(()=>{
	addEventListener("keydown", (ev)=>{
			let a=ev.getModifierState("Alt")
			if(ev.code === "Digit1") {
				if(!a) buyAD(1)
				else g.prestige.autobuyers[1] = !g.prestige.autobuyers[1]
			}
			if(ev.code === "Digit2") {
				if(!a) buyAD(2)
				else g.prestige.autobuyers[2] = !g.prestige.autobuyers[2]
			}
			if(ev.code === "Digit3") {
				if(!a) buyAD(3)
				else g.prestige.autobuyers[3] = !g.prestige.autobuyers[3]
			}
			if(ev.code === "Digit4") {
				if(!a) buyAD(4)
				else g.prestige.autobuyers[4] = !g.prestige.autobuyers[4]
			}
			if(ev.code === "KeyT") {
				if(!a) buyTick(5)
				else g.prestige.autobuyers[5] = !g.prestige.autobuyers[5]
			}
			if(ev.code === "KeyP") {
				if(!a) prestige(6)
				else g.prestige.autobuyers[6] = !g.prestige.autobuyers[6]
			}
			if(ev.code === "KeyD") {
				buyFlune()
			}
			
			if(a) event.preventDefault();
		}	
	)
	if(!localStorage.getItem("save")){
		saveGame();
	} else {
		loadGame();
	}
	setInterval(gameTick, dTime * 1000);
	setInterval(saveGame, 15_000);
	}
);
function exportSave(){
	document.getElementById("saveworks").value = btoa(JSON.stringify(g));
}
function importSave(){
	localStorage.setItem("save", document.getElementById("saveworks").value);
	loadGame();
}
function loadGame(){
	let q = JSON.parse(atob(localStorage.getItem("save")))
	merge(g,q)
	g.a = F(g.a);
	g.tick = F(g.tick)
	for (let i = 1; i <= 4; i++) g.ads[i] = F(g.ads[i]);
	for (let i = 1; i <= 4; i++) g.adps[i] = F(g.adps[i]);
	for (let i = 1; i <= 4; i++) g.adcms[i] = F(g.adcms[i]);
	for (let i = 1; i <= 4; i++) g.adics[i] = F(g.adics[i]);
	g.prestige.points = F(g.prestige.points)
	g.prestige.times = F(g.prestige.times)
	g.flunes = F(g.flunes);
	g.prestige.autobuy = F(g.prestige.autobuy)
	g.prestige.maxPoints = F(g.prestige.maxPoints)
	g.maxFlunes = F(g.maxFlunes)
	if(g.ver < 260721){ // preliminary changes before adding other geometries, flune thing
		g.ver = 260721
		g.prestige.maxPoints = g.prestige.points
		g.maxFlunes = g.flunes
	}
	if(g.ver < 260723) // challenge 1
		g.ver = 260723
	
}
function gameTick(){
	let t = dTime;
	if(g.chall.flune.in == 0){
		for(const i of [1,2,3,4]){
			if(g.flunes.gte(i) && g.prestige.autobuyers[i]){
				let bruple = g.a.log10()
					.sub(g.adics[i].log10())
					.div(g.adcms[i].log10())
					.ceil();
				g.ads[i] = D.max(bruple, g.ads[i])
				g.adps[i] = D.max(bruple, g.adps[i])
			}
		}
		if(g.flunes.gte(5) && g.prestige.autobuyers[5]){
			g.tick = D.max(g.tick,
				g.a.log10()
				.sub(2).div(2)
				.pow(E(1).div(tickscale())).ceil()
			);
		}
		if(pendingPoints().gte(g.prestige.autobuy) && g.flunes.gte(6) && g.prestige.autobuyers[6] && g.chall.flune.in == 0) {
			prestige()
		}
	}
	let bloftsap = g.a.plus(persec(0).mul(t))
	if(bloftsap.gte(hardcap) && !false) {
		g.a = hardcap;
	} else g.a = bloftsap;
	g.ads[1] = g.ads[1].plus(persec(1).mul(t));
	g.ads[2] = g.ads[2].plus(persec(2).mul(t));
	g.ads[3] = g.ads[3].plus(persec(3).mul(t));
}
function saveGame(){
	localStorage.setItem("save", btoa(JSON.stringify(g)));
}
function delSave(){
	localStorage.removeItem("save");
	location.reload();
}
function baseMPS(){
	let tickmul = g.tick.mul(tickpower()).plus(2);
	let base = g.ads[1].mul(tickmul.pow(g.adps[1]));
	if(g.flunes.gt(0) && g.prestige.maxPoints.gt(1)) base = base.mul(g.prestige.maxPoints.pow(E(0.5).mul(g.flunes)))
	if(g.prestige.upgs[1]) base = base.mul(2);
	return base;
}
function softcapStart(){
	return g.chall.flune.in == 1 ? E(1) : g.flunes.pow(2).add(20).mul(g.chall.flune.comp[1]+1)
}
function softcapPower(){
	if(g.chall.flune.in == 1) return E(0.75)
	if(g.flunes.gt(0)) return E(0.99).pow(g.flunes).mul(0.25).add(0.2).mul(g.chall.flune.comp>0?0.9:1);
	if(g.prestige.upgs[6]) return E(0.45)
	else return E(0.5)
}
function persec(n) {
	let tickmul = g.tick.mul(tickpower()).plus(2);
	let base = g.ads[n+1].mul(tickmul.pow(g.adps[n+1])).div(n===0||g.prestige.upgs[2]?1:8);
	if(g.flunes.gt(0) && g.prestige.maxPoints.gt(1)) base = base.mul(g.prestige.maxPoints.pow(E(0.5).mul(g.flunes)))
	if(g.prestige.upgs[1]) base = base.mul(2);
	if(n !== 0) return base;
	if(g.a.gte(hardcap)) return E(0);
	if(base.gt(D.pow10(softcapStart())))
		base = base.pow(
			new D(softcapStart()).div(base.log10()).pow(softcapPower())
		);
	return base;
}
function tickpower(){
	if(g.flunes.gt(0)) return g.flunes.mul(0.02).add(0.3)
	if(g.prestige.upgs[4]) return E(0.3)
	else return E(0.25)
}
function tickscale(){
	if(g.flunes.gt(0)) return E(0.9).pow(g.flunes).mul(0.2).add(1.05);
	if(g.prestige.upgs[5]) return 1.2
	if(g.prestige.upgs[3]) return 1.25
	else return 1.3
}
function tickcost(){
	return E(10).pow(g.tick.pow(tickscale()).mul(2).floor()).mul(100);
}
function dimcost(n){
	return g.adcms[n].pow(g.adps[n]).mul(g.adics[n]);
}
function flunecost(){
	return E(2).pow(g.flunes.add(1).pow(1.125)).floor()
}
function buyAD(n) {
	let cost = dimcost(n);
	if (g.a.gte(cost)) {
		g.a = g.a.sub(cost);
		g.adps[n] = g.adps[n].plus(1);
		g.ads[n] = g.ads[n].plus(1);
		return true;
	}
	return false;
}
function buyTick() {
	let cost = tickcost();
	if (g.a.gte(cost)) {
		g.a = g.a.sub(cost);
		g.tick = g.tick.plus(1);
		return true;
	}
	return false;
}
function buyFlune(){
	let cost = flunecost();
	if(g.prestige.points.gte(cost)) {
		g.prestige.points = g.prestige.points.sub(cost);
		g.flunes = g.flunes.add(1);
		g.maxFlunes = D.max(g.maxFlunes, g.flunes)
		return true;
	}
	return false;
}
function pendingPoints(){
	if(!g.prestige.upgs[8]) return E(1);
	else return D.max(g.tick.sub(6),0)
}
function prestigereset(){
	if(g.prestige.upgs[7]) g.a = g.prestige.times.add(1).pow(2);
	else g.a = E(1);
	g.tick = E(0);
	for (let i = 1; i <= 4; i++) g.ads[i] = E(0);
	for (let i = 1; i <= 4; i++) g.adps[i] = E(0);
}
function prestige(){
	if(g.tick.gt(6)) {
		g.prestige.points = g.prestige.points.add(pendingPoints());
		g.prestige.times = g.prestige.times.add(1);
		prestigereset();
		g.prestige.maxPoints = D.max(g.prestige.points, g.prestige.maxPoints)
	}
}
function setPrestigeAutobuyer(){
	let buyer = F(document.getElementById("prestigeautobuyer").value)
	if(buyer !== "NaN") {
		g.prestige.autobuy = buyer;
	}
}
function buyPUpgrade(n){
	if((g.prestige.upgs[n-2] || n <= 2) && // if previous
		(!g.prestige.upgs[n])&& // if not already bought
		(g.prestige.points.gte(1))&& // if you have the currency
		( n !== 8 || g.prestige.upgs[7])) { // making sure number 8
		g.prestige.upgs[n] = true;
		g.prestige.points = g.prestige.points.sub(1)
	}
}
function enterChall(n){
	g.chall.flune.in = n
	prestigereset()
	g.a = E(1)
}
function exitChall(){
	if(g.tick.gte(1+g.chall.flune.comp[g.chall.flune.in])){
		g.chall.flune.comp[g.chall.flune.in]++
	}
	g.chall.flune.in = 0
	prestigereset()
}
function notate(x) { 
	let j = new Decimal(x)
	let output = ""
	let r = j.abs()
	if(r.lt(100)) {
		output = r.toFixed(2)
	} else if (r.lt(1000)) {
		output = r.toFixed(1)
	} else if (r.lt(1e6)) {
		output = r.toFixed(0)
	} else if (r.lt("e10000")) {
		output = basenum(r, 2)
	} else if (r.lt("e1e6")) {
		output = basenum(r,1)
	} else if (r.lt("ee10000")) {
		output = "e" + basenum(r.log10(), 2)
	} else if (r.lt("ee1e6")) {
		output = "e" + basenum(r.log10(), 1)
	} else output = r.toString()
	return j.lt(0)?'-':'' + output
}

function basenum(x, p) {
	let exponent = x.log10().floor();
	let mantissa = x.div(Decimal.pow10(exponent));
	return mantissa.toFixed(p)+"e"+exponent.toFixed(0)
}
</script>
<style>
	* {
		background-color: #222;
		color: #fff;
		font-family: monospace;
	}
	button {
		border-style: solid;
		border-radius: 8px;
		border-color: #333;
		background-color: #fff;
		color: #000;
	}
	table, td {
		border: none;
	}
	td {
		height: 100%;
	}
	td > button {
		width: 100%;
		height: 100%;
		text-align: left;
	}
	.center {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.stack {
		flex-direction: column;
	}
	h1 {
		font-size: 56px;
	}
	div *:not(h1) {
		font-size: 24px;
	}
	
</style>
<template>
	<div>
		<div class="center stack">
			<h1>You have <span style="color: #f00; font-size:72px;">{{ notate(g.a) }}</span> manifolds. (+{{notate(persec(0))}}/s)</h1>
			<div v-if="g.prestige.times > 0">You have <span style="color: #00f;">{{ notate(g.prestige.points) }}</span> prestige points.</div>
			<br />
			<div>
				<button @click="tab = 'dim'" style="background-color: #933;">Producers</button>
				<button @click="tab = 'opt'" style="background-color: #ccc;">Options</button>
				<button @click="tab = 'pre'" style="background-color: #33f;" v-if="g.prestige.times>0">Prestige</button>
				<button @click="tab = 'fln'" style="background-color: #993;" v-if="g.prestige.upgs[8]">Geometry</button>
				<button @click="tab = 'chl'" style="background-color: #907;" v-if="g.maxFlunes.gte(7)">Challenges</button>
			</div>
			<div>
				<button v-if="(g.tick.gt(6) || g.prestige.times.gt(10)) && g.chall.flune.in == 0" @click='prestige' style="background-color: #33f;">
					Prestige for {{ notate(pendingPoints()) }} point{{pendingPoints()!==1?'s':''}}!
				</button>
				<button v-if="g.chall.flune.in != 0" style="background-color: #907;" @click="exitChall">
					Exit/Finish challenge!
				</button>
			</div>	
		</div>
		<div v-if="tab==='dim'">
			<div class="center" v-if="g.ads[1].gt(0)">
				<button @click="buyTick" :style='{"background-color": g.a.gte(tickcost())?"#cfc":"#7a7"}'>
					Cost: {{notate(tickcost())}}
				</button>
				You have {{notate(g.tick)}} theorems<span v-if="g.tick.gt(0)">, making per-purchase multipliers {{notate(g.tick.mul(tickpower()).plus(2))}}</span>
			</div>
			<br />
			<table>
				<tr>
					<td>
						<button @click="buyAD(1)" :style='{"background-color": g.a.gte(dimcost(1))?"#fff":"#777"}'>
							Cost: {{notate(dimcost(1))}}
						</button>
					</td>
					<td>
						Points
					</td>
					<td>
						| You have {{notate(g.ads[1])}}
						<span v-if="g.ads[2]>0">({{notate(g.adps[1])}})</span>
					</td>
					<td>
						<span v-if="g.ads[2]>0">| (+{{notate(persec(1))}}/s)</span>
					</td>
				</tr>
				<tr v-if="g.ads[1]>0">
					<td>
						<button @click="buyAD(2)" :style='{"background-color": g.a.gte(dimcost(2))?"#fff":"#777"}'>
							Cost: {{notate(dimcost(2))}}
						</button>
					</td>
					<td>
						Lines
					</td>
					<td>
						| You have {{notate(g.ads[2])}}
						<span v-if="g.ads[3]>0"> ({{notate(g.adps[2])}})</span>
					</td>
					<td>
						<span v-if="g.ads[3]>0">| (+{{notate(persec(2))}}/s)</span>
					</td>
				</tr>
				<tr v-if="g.ads[2]>0">
					<td>
						<button @click="buyAD(3)" :style='{"background-color": g.a.gte(dimcost(3))?"#fff":"#777"}'>
							Cost: {{notate(dimcost(3))}}
						</button>
					</td>
					<td>
						Planes
					</td>
					<td>
						| You have {{notate(g.ads[3])}}
						<span v-if="g.ads[4]>0"> ({{notate(g.adps[3])}})</span>
					</td>
					<td>
						<span v-if="g.ads[4]>0">| (+{{notate(persec(3))}}/s)</span>
					</td>
				</tr>
				<tr v-if="g.ads[3]>0">
					<td>
						<button @click="buyAD(4)" :style='{"background-color": g.a.gte(dimcost(4))?"#fff":"#777"}'>
							Cost: {{notate(dimcost(4))}}
						</button>
					</td>
					<td>Cells</td>
					<td>| You have {{notate(g.adps[4])}}</td>
				</tr>
			</table>
			<br />
			<div v-if="baseMPS().gt(D.pow10(softcapStart()))">
				Above {{ notate(D.pow10(softcapStart())) }} manifolds per second, manifold production is divided by {{ notate(baseMPS().pow(E(1).sub((softcapStart().div(baseMPS().log10())).pow(softcapPower()))), 4) }}
			</div>
			<div v-if="g.a.gte(hardcap)">
				Manifolds are hardcapped at {{ notate(hardcap) }}.
			</div>
		</div>
		<div v-if="tab==='opt'">
			<div class="center">
				<table class="prestige">
					<tr>
						<td>
							<button @click="delSave" style="background-color: #f33;">
								Delete save
							</button>
						</td>
					</tr>
					<tr>
						<td>
							<button @click="saveGame">
								Save game
							</button>
						</td>
					</tr>
					<tr>
						<td>
							<button @click="exportSave">
								Export save
							</button>
						</td>
					</tr>
					<tr>
						<td>
							<button @click="importSave">
								Import save
							</button>
						</td>
					</tr>
				</table>
				<br />
				<textarea id="saveworks"></textarea>

				<br />
			</div>
		</div>
		<div v-if="tab==='pre'">
			You have <span style="color: #33f">{{ notate(g.prestige.points) }}</span> prestige points.
			<br />
			Each upgrade costs 1 prestige point.
			<br />
			Upgrades must be purchased in each column top down. (ie. you need the 1st to get the 3rd, but you don't need the 2nd)
			<br />
			The eighth upgrade requires all other upgrades to be purchased.
			<table class="prestige">
				<tr>
					<td>
						<button :style='{"background-color": g.prestige.upgs[1]?"#33f":"#333"}'
						@click="buyPUpgrade(1)">Upgrade 1: Double all generator mults</button>
					</td>
					<td>
						<button :style='{"background-color": g.prestige.upgs[2]?"#33f":"#333"}'
						@click="buyPUpgrade(2)">Upgrade 2: Remove &div;8 nerf on Lines, Planes, and Cell</button>
					</td>
				</tr>
				<tr>
					<td>
						<button :style='{"background-color": g.prestige.upgs[3]?"#33f":"#333"}'
						@click="buyPUpgrade(3)">Upgrade 3: Weaken theorem cost scaling (1.3 =&gt; 1.25)</button>
					</td>
					<td>
						<button :style='{"background-color": g.prestige.upgs[4]?"#33f":"#333"}'
						@click="buyPUpgrade(4)">Upgrade 4: Increase theorem power (0.25 =&gt; 0.3)</button>
					</td>
				</tr>
				<tr>
					<td>
						<button :style='{"background-color": g.prestige.upgs[5]?"#33f":"#333"}'
						@click="buyPUpgrade(5)">Upgrade 5: Further weaken theorem cost scaling (1.25 =&gt; 1.2)</button>
					</td>
					<td>
						<button :style='{"background-color": g.prestige.upgs[6]?"#33f":"#333"}'
						@click="buyPUpgrade(6)">Upgrade 6: Weaken manifold softcap by 5% (0.5 =&gt; 0.45)</button>
					</td>
				</tr>
				<tr>
					<td>
						<button :style='{"background-color": g.prestige.upgs[7]?"#33f":"#333"}'
						@click="buyPUpgrade(7)">Upgrade 7: Start with some manifolds after prestige (currently {{ notate(g.prestige.times.add(1).pow(2)) }})</button>
					</td>
					<td>
						<button :style='{"background-color": g.prestige.upgs[8]?"#33f":"#333"}'
						@click="buyPUpgrade(8)">Upgrade 8: You can get more than 1 prestige point per reset</button>
					</td>
				</tr>
			</table>
			<br />
			<br />
			<button @click="prestigereset">Force a prestige reset</button>
		</div>
		<div v-if="tab==='fln'">
			You have a 3 + {{ notate(g.flunes) }} = {{ notate(g.flunes.add(3)) }} dimensional geometry.
			<br />
			Extrude into a new dimension:
			<button @click="buyFlune" :style='{"background-color": g.prestige.points.gte(flunecost())?"#fff":"#777"}'>
				Cost: {{ notate(flunecost()) }} prestige points
			</button>
			<br />
			They make your theorem scaling {{ notate(tickscale()) }},
			your theorem power {{ notate(tickpower()) }},
			your softcap power {{ notate(softcapPower()) }},
			and your softcap start {{ notate(D.pow10(softcapStart())) }}.
			Dimensions will also give you automation for the first 9.
			They are also multiplying producers by prestige points^{{ notate(E(0.5).mul(g.flunes)) }}.
			<br />
			<div v-if="g.maxFlunes.gte(1)">
				<input type="checkbox" v-model="g.prestige.autobuyers[1]" />
				Point Autobuyer
			</div>
			<div v-if="g.maxFlunes.gte(2)">
				<input type="checkbox" v-model="g.prestige.autobuyers[2]" />
				Line Autobuyer
			</div>
			<div v-if="g.maxFlunes.gte(3)">
				<input type="checkbox" v-model="g.prestige.autobuyers[3]" />
				Plane Autobuyer
			</div>
			<div v-if="g.maxFlunes.gte(4)">
				<input type="checkbox" v-model="g.prestige.autobuyers[4]" />
				Cell Autobuyer
			</div>
			<div v-if="g.maxFlunes.gte(5)">
				<input type="checkbox" v-model="g.prestige.autobuyers[5]" />
				Theorem Autobuyer
			</div>
			<div v-if="g.maxFlunes.gte(6)">
				<input type="checkbox" v-model="g.prestige.autobuyers[6]" />
				Prestige Autobuyer
				<input id="prestigeautobuyer" @change="setPrestigeAutobuyer"/>
			</div>
		</div>
		<div v-if="tab==='chl'">
			In challenges, autobuyers and PU7 are disabled. <br />
			<button @click="enterChall(1)">
				Challenge 1: Softcap starts at 10, and softcap strength is 75% <br />
				Goal: {{ 1+g.chall.flune.comp[1] }} theorems. <br />
				{{ g.chall.flune.comp[1] }} completions <br />
				Reward: ^{{ g.chall.flune.comp[1]+1 }} to theorem softcap, <br />
				&times;{{ g.chall.flune.comp[1] > 0 ? 0.9 : 1 }} to softcap strength.
			</button>
		</div>
	</div>
</template>